(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.alma-home-layout marquee-component').forEach((marquee) => {
      if (marquee.dataset.almaReady) return;
      const wrapper = marquee.querySelector('.marquee__wrapper');
      const content = marquee.querySelector('.marquee__content');
      const original = content?.querySelector('.marquee__repeated-items');
      if (!wrapper || !content || !original) return;
      marquee.dataset.almaReady = 'true';
      const seed = original.cloneNode(true);
      let previousWidth = 0;
      const rebuild = () => {
        if (!marquee.isConnected) { observer.disconnect(); return; }
        const width = marquee.clientWidth;
        if (!width || width === previousWidth) return;
        previousWidth = width;
        wrapper.replaceChildren(content);
        content.replaceChildren(seed.cloneNode(true));
        const item = content.firstElementChild;
        const gap = parseFloat(getComputedStyle(content).gap) || 32;
        const unit = item.getBoundingClientRect().width + gap;
        if (!unit) return;
        const count = Math.max(1, Math.ceil(width / unit));
        for (let index = 1; index < count; index++) {
          const copy = seed.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          content.appendChild(copy);
        }
        const duplicate = content.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        wrapper.appendChild(duplicate);
        marquee.style.setProperty('--alma-marquee-duration', ((content.getBoundingClientRect().width + gap) / 30) + 's');
      };
      const observer = new ResizeObserver(rebuild);
      observer.observe(marquee);
      rebuild();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', () => initialize());
})();